// extracted by mini-css-extract-plugin
export default {"container":"DF-z","disabled":"EF-z","bgBlack":"FF-z","content":"GF-z","countdown":"HF-z","topCaption":"IF-z","topHeading":"JF-z","heading":"KF-z","copy":"LF-z"};